import React from "react";
import Breadcrumbs from "../BreadCrum/BreadCrum";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { primaryColor, secondaryColor } from "../../../utils/comon";

const PageHeadingSection = ({
    mainHeading,
    subHeading,
    primaryBtnText,
    primaryBtnIcon,
    PrimaryOnClick,
    seconadaryBtnText,
    seconadaryBtnIcon,
    SecandaryOnClick,
    primaryBtnDisabled
}) => {
    return (
        <div className="bg-sectionheaderbg border border-bordercolor flex flex-col items-start lg:flex-row lg:items-center lg:justify-between rounded-xl px-4 py-2">

            <div>
                <div className="mb-4">
                    <h1 className="text-sm sm:text-lg font-bold text-textprimary">
                        {mainHeading}
                    </h1>

                    {subHeading && (
                        <p className="text-xs text-textsecondary mt-2 whitespace-pre-line">
                            {subHeading}
                        </p>
                    )}
                </div>
            </div>

            <div className="flex lg:flex-row gap-2 mb-4">

                {/* Secandary Button */}

                {seconadaryBtnText && <button className={`border border-bordercolor px-2 py-2 bg-cardbg text-textprimary text-xs font-medium rounded-lg 
                                   flex items-center justify-center sm:justify-start gap-1`}
                    onClick={SecandaryOnClick}>
                    <FontAwesomeIcon icon={seconadaryBtnIcon} className="text-[14px]" />
                    {seconadaryBtnText}
                </button>}

                {/* Primary Button */}

                {primaryBtnText && (
                    <div className="relative group inline-block">
                        <button
                            className={`border py-2 px-2 text-xs font-medium rounded-lg flex items-center justify-center sm:justify-start gap-1 transition-all duration-200 shadow-sm ${primaryBtnDisabled ? "text-gray-300 cursor-not-allowed bg-gray-50 border-gray-200" : "hover:shadow-md active:scale-95"}`}
                            style={primaryBtnDisabled ? {} : { backgroundColor: "var(--color-secondaryaccent)", color: "var(--color-primaryaccent)", borderColor: "var(--color-accentborder)" }}
                            onMouseEnter={(e) => {
                                if (!primaryBtnDisabled) {
                                    e.currentTarget.style.backgroundColor = "var(--color-primaryaccent)";
                                    e.currentTarget.style.color = "var(--color-cardbg)";
                                }
                            }}
                            onMouseLeave={(e) => {
                                if (!primaryBtnDisabled) {
                                    e.currentTarget.style.backgroundColor = "var(--color-secondaryaccent)";
                                    e.currentTarget.style.color = "var(--color-primaryaccent)";
                                }
                            }}
                            onClick={primaryBtnDisabled ? undefined : PrimaryOnClick}
                            disabled={primaryBtnDisabled}
                        >
                            <FontAwesomeIcon icon={primaryBtnIcon} className={`text-[14px] ${primaryBtnDisabled ? "text-gray-300" : ""}`} />
                            {primaryBtnText}
                        </button>

                        {primaryBtnDisabled && (
                            <div className="absolute right-0 bottom-full mb-2 z-[999] invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-all duration-300 pointer-events-none">
                                <div className="bg-[#1E293B] text-white text-xs font-medium py-1.5 px-3 rounded-lg shadow-xl whitespace-nowrap relative">
                                    You don't have permission for this action
                                    <div className="w-2 h-2 bg-[#1E293B] rotate-45 absolute right-4 -bottom-1"></div>
                                </div>
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default PageHeadingSection;